/**
 * Timezone Options
 *
 * Shared timezone options for use across Settings components.
 * Format: (UTC offset) Region description
 *
 * Used by:
 * - DeliveryPreferencesCard (main timezone selector)
 * - QuietHoursSection (quiet hours timezone selector)
 */

export interface TimezoneOption {
  label: string;
  value: string;
}

export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  { label: '(UTC-12:00) International Date Line West', value: 'Etc/GMT+12' },
  { label: '(UTC-11:00) Midway Island, Samoa', value: 'Pacific/Samoa' },
  { label: '(UTC-10:00) Hawaii', value: 'Pacific/Honolulu' },
  { label: '(UTC-09:00) Alaska', value: 'America/Anchorage' },
  { label: '(UTC-08:00) Pacific Time (US & Canada)', value: 'America/Los_Angeles' },
  { label: '(UTC-07:00) Mountain Time (US & Canada)', value: 'America/Denver' },
  { label: '(UTC-06:00) Central Time (US & Canada)', value: 'America/Chicago' },
  { label: '(UTC-05:00) Eastern Time (US & Canada)', value: 'America/New_York' },
  { label: '(UTC-04:00) Atlantic Time (Canada)', value: 'America/Halifax' },
  { label: '(UTC-03:00) Buenos Aires, Georgetown', value: 'America/Buenos_Aires' },
  { label: '(UTC-02:00) Mid-Atlantic', value: 'Etc/GMT+2' },
  { label: '(UTC-01:00) Azores', value: 'Atlantic/Azores' },
  { label: '(UTC+00:00) London, Dublin, Lisbon', value: 'Europe/London' },
  { label: '(UTC+01:00) Paris, Berlin, Rome', value: 'Europe/Paris' },
  { label: '(UTC+02:00) Cairo, Athens, Helsinki', value: 'Europe/Athens' },
  { label: '(UTC+03:00) Moscow, Kuwait, Riyadh', value: 'Europe/Moscow' },
  { label: '(UTC+04:00) Abu Dhabi, Muscat, Baku', value: 'Asia/Dubai' },
  { label: '(UTC+05:00) Islamabad, Karachi', value: 'Asia/Karachi' },
  { label: '(UTC+05:30) Chennai, Kolkata, Mumbai', value: 'Asia/Kolkata' },
  { label: '(UTC+06:00) Almaty, Dhaka', value: 'Asia/Dhaka' },
  { label: '(UTC+07:00) Bangkok, Hanoi, Jakarta', value: 'Asia/Bangkok' },
  { label: '(UTC+08:00) Beijing, Hong Kong, Singapore', value: 'Asia/Shanghai' },
  { label: '(UTC+09:00) Tokyo, Seoul', value: 'Asia/Tokyo' },
  { label: '(UTC+09:30) Adelaide', value: 'Australia/Adelaide' },
  { label: '(UTC+10:00) Sydney, Melbourne, Brisbane', value: 'Australia/Sydney' },
  { label: '(UTC+11:00) Solomon Islands', value: 'Pacific/Guadalcanal' },
  { label: '(UTC+12:00) Auckland, Wellington, Fiji', value: 'Pacific/Auckland' },
];
